import Phaser from 'phaser';

const SKY_TOP = 0x2a0052;
const SKY_MID = 0x5b1d85;
const SKY_BOT = 0x120033;
const NEBULA_PINK = 0xe879f9;
const NEBULA_PURPLE = 0x7c3aed;
const STAR_WHITE = 0xfafafa;
const STAR_GOLD = 0xfde68a;
const GALAXY_ARM = 0x60a5fa;

export function drawGalactusSkyBackground(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
) {
  g.clear();
  const step = Math.max(1, Math.floor(h / 48));
  for (let y = 0; y < h; y += step) {
    const t = y / h;
    let r: number, gC: number, b: number;
    if (t < 0.55) {
      const u = t / 0.55;
      r = lerp((SKY_TOP >> 16) & 0xff, (SKY_MID >> 16) & 0xff, u);
      gC = lerp((SKY_TOP >> 8) & 0xff, (SKY_MID >> 8) & 0xff, u);
      b = lerp(SKY_TOP & 0xff, SKY_MID & 0xff, u);
    } else {
      const u = (t - 0.55) / 0.45;
      r = lerp((SKY_MID >> 16) & 0xff, (SKY_BOT >> 16) & 0xff, u);
      gC = lerp((SKY_MID >> 8) & 0xff, (SKY_BOT >> 8) & 0xff, u);
      b = lerp(SKY_MID & 0xff, SKY_BOT & 0xff, u);
    }
    g.fillStyle((r << 16) | (gC << 8) | b, 1);
    g.fillRect(0, y, w, step + 1);
  }

  const rand = mulberry32(7777);

  g.fillStyle(NEBULA_PINK, 0.22);
  for (let i = 0; i < 5; i++) {
    const cx = rand() * w;
    const cy = rand() * h * 0.8;
    const rr = 90 + rand() * 140;
    g.fillEllipse(cx, cy, rr * 2, rr);
  }

  g.fillStyle(NEBULA_PURPLE, 0.25);
  for (let i = 0; i < 4; i++) {
    const cx = rand() * w;
    const cy = h * 0.1 + rand() * h * 0.7;
    const rr = 110 + rand() * 160;
    g.fillEllipse(cx, cy, rr * 2, rr * 0.8);
  }

  for (let i = 0; i < 140; i++) {
    const sx = rand() * w;
    const sy = rand() * h;
    const twinkle = rand();
    const color = twinkle > 0.85 ? STAR_GOLD : STAR_WHITE;
    const sz = twinkle > 0.95 ? 2 : 1;
    g.fillStyle(color, 0.5 + rand() * 0.5);
    g.fillRect(sx, sy, sz, sz);
  }
}

export function drawGalactusSilhouette(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
  _seed = 7777,
) {
  const cx = Math.floor(w * 0.3);
  const cy = Math.floor(h * 0.6);

  g.fillStyle(GALAXY_ARM, 0.35);
  g.fillEllipse(cx, cy, 260, 80);
  g.fillStyle(NEBULA_PINK, 0.45);
  g.fillEllipse(cx, cy, 160, 50);
  g.fillStyle(0xfef3c7, 0.95);
  g.fillCircle(cx, cy, 10);
  g.fillStyle(0xffffff, 0.6);
  g.fillCircle(cx, cy, 4);

  const px = Math.floor(w * 0.78);
  const py = Math.floor(h * 0.55);
  g.fillStyle(0x22c55e, 0.85);
  g.fillCircle(px, py, 26);
  g.fillStyle(0x16a34a, 1);
  g.fillEllipse(px - 6, py + 2, 18, 8);
  g.fillEllipse(px + 8, py - 4, 14, 6);
  g.fillStyle(0xfde68a, 0.6);
  g.fillCircle(px - 10, py - 12, 3);

  g.fillStyle(0xf97316, 0.8);
  g.fillCircle(Math.floor(w * 0.88), Math.floor(h * 0.78), 14);
  g.fillStyle(0xea580c, 1);
  g.fillEllipse(Math.floor(w * 0.88), Math.floor(h * 0.78), 24, 4);

  const baselineY = Math.floor(h * 0.88);
  g.fillStyle(0x1e1a2e, 1);
  g.fillRect(0, baselineY, w, h - baselineY);
  g.fillStyle(0x2e1a4b, 0.7);
  for (let i = 0; i < w; i += 40) {
    g.fillRect(i, baselineY, 20, 4);
  }
}

function lerp(a: number, b: number, t: number): number {
  return Math.round(a + (b - a) * t);
}

function mulberry32(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
